<div *transloco="let t">
	<div>{{ t('cloud.add-devices-dialog.claim-by-qr-code.scan-qr-codes-message') }}</div>

	<div class="sh-org-switcher-container">
		<prism-label-value data-testid="organization-name-label-value">
			<span slot="label">{{ t('cloud.add-devices-dialog.claim-by-qr-code.organization-owning-devices') }}</span>
			{{ organizationName() }}
		</prism-label-value>
		<prism-button data-testid="sh-change-org-button" variant="bright" (click)="onChangeOrganizationClick()">
			{{ t('cloud.shared.switch-org.change') }}
		</prism-button>
	</div>
	<div class="prism-caption sh-org-refresh-message">
		{{ t('cloud.add-devices-dialog.claim-by-qr-code.changing-organization-will-refresh-message') }}
	</div>

	<div class="sh-video-container">
		<video
			#scanPreview
			class="sh-video"
			data-testid="scan-preview-video"
			[autoplay]="true"
			[playsInline]="true"
			[muted]="true"
			disablepictureinpicture
			(loadeddata)="onVideoLoaded()"
		></video>
		<div class="sh-video-overlay" [class.sh-overlay-film]="isSaving()">
			@if (hasCameraAccess() === false) {
				<div
					class="prism-caption sh-enable-browser-permissions-message"
					data-testid="enable-camera-permissions-message"
				>
					{{ t('cloud.add-devices-dialog.claim-by-qr-code.enable-camera-permissions-message') }}
				</div>
			}
			@if (isSaving()) {
				<prism-progress-indicator type="circular" data-testid="progress-indicator"></prism-progress-indicator>
			}
		</div>
	</div>

	@if (statusMessage()) {
		<div [class]="['sh-status-message-container', statusMessage()?.class]">
			<prism-icon icon="sh-error-outline" size="sm"></prism-icon>
			<span class="prism-caption" data-testid="status-message">{{ t(statusMessage()!.translocoKey) }}</span>
		</div>
	}

	<div class="sh-codes-scanned-text" data-testid="codes-scanned-text">
		{{ t('cloud.add-devices-dialog.claim-by-qr-code.codes-scanned', { count: scannedCodes()?.length }) }}
	</div>
</div>
